import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { BillingProvider } from './context/BillingContext';
import { msalConfig } from './msalConfig';

const msalInstance = new PublicClientApplication(msalConfig);

import Login from './pages/Login';
import Signup from './pages/Signup';
import Landing from './pages/Landing';
import Layout from './components/Layout';

import Portfolio from './pages/Portfolio';
import PortcoDetail from './pages/PortcoDetail';
import Intake from './pages/Intake';
import Reports from './pages/Reports';
import Normalization from './pages/Normalization';
import Settings from './pages/Settings';
import Billing from './pages/Billing';
import SuperAdmin from './pages/SuperAdmin';
import Monitoring from './pages/Monitoring';
import Sourcing from './pages/Sourcing';

function ProtectedRoute() {
  const { token, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center text-navy-900">
        <div className="flex items-center gap-3">
          <svg className="animate-spin h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span className="font-medium text-slate-300">Loading Caply...</span>
        </div>
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

export default function App() {
  return (
    <MsalProvider instance={msalInstance}>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<BillingProvider><Layout /></BillingProvider>}>
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/portfolio/:portcoId" element={<PortcoDetail />} />
              <Route path="/new-deal" element={<Intake />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/platform" element={<SuperAdmin />} />
              {/* Redirect old routes */}
              <Route path="/dashboard" element={<Navigate to="/portfolio" replace />} />
              <Route path="/intake" element={<Navigate to="/new-deal" replace />} />
              <Route path="/normalization" element={<Normalization />} />
              <Route path="/monitoring" element={<Monitoring />} />
              <Route path="/sourcing" element={<Sourcing />} />
              <Route path="/agents" element={<Navigate to="/settings" replace />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </MsalProvider>
  );
}
